export const LISTING_PAGE_CLASS = "min-h-screen bg-[#EEF2F7] p-4 sm:p-6";
export const LISTING_CONTAINER_CLASS = "mx-auto max-w-7xl";

export const FILTER_LABEL_CLASS =
  "mb-1.5 block text-[11px] font-medium uppercase tracking-wide text-slate-400";

export const FILTER_FIELD_CLASS =
  "h-10 w-full rounded-xl border border-slate-200 bg-white px-3 text-sm text-slate-700 outline-none transition focus:border-[#2B7FFF] focus:ring-2 focus:ring-[#2B7FFF]/15";

export const LISTING_CARD_CLASS =
  "overflow-hidden rounded-2xl border border-slate-200/80 bg-white shadow-sm";

export const LISTING_FILTER_CARD_CLASS =
  "mb-6 rounded-2xl border border-slate-200/80 bg-white p-5 shadow-sm";

export const LISTING_PRIMARY_BUTTON_CLASS =
  "inline-flex h-10 items-center gap-2 rounded-xl bg-[#2B7FFF] px-4 text-sm font-semibold text-white shadow-sm transition hover:bg-[#1d6ef2]";

export const LISTING_TABLE_HEAD_CLASS =
  "border-b border-slate-100 bg-slate-50/80 text-left";

export const LISTING_TABLE_HEADER_CELL_CLASS =
  "px-4 py-3 text-[11px] font-semibold uppercase tracking-wide text-slate-500";

export const LISTING_TABLE_ROW_CLASS =
  "border-t border-slate-100 transition hover:bg-slate-50/70";

export const LISTING_ICON_ACTION_CLASS =
  "inline-flex h-9 w-9 items-center justify-center rounded-xl border border-slate-200 text-slate-600 transition hover:border-[#2B7FFF]/30 hover:bg-blue-50 hover:text-[#2B7FFF]";

export const LISTING_ICON_ACTION_DANGER_CLASS =
  "inline-flex h-9 w-9 items-center justify-center rounded-xl border border-slate-200 text-slate-600 transition hover:border-red-200 hover:bg-red-50 hover:text-red-600";
